module.exports = __webpack_public_path__ + "static/media/confirmRouteActionIcon.08a565c0.svg";